const locale = {
  UNIVERSAL_LINKS: 'Універсальні посилання',
  UNIVERSAL_LINKS_SUBTITLE:
    'Одне посилання, яке може відкрити будь-яка кількість людей. Кожна людина підтверджує свою електронну пошту перед початком верифікації.',
  CREATE_LINK: 'Створити посилання',
  EDIT_LINK: 'Редагувати посилання',
  NAME: 'Назва',
  NAME_PLACEHOLDER: 'Наприклад, Реєстрація на сайті',
  LINK: 'Посилання',
  FLOW: 'Процес перевірки',
  SELECT_FLOW: 'Оберіть процес перевірки',
  APPLICATION: 'Додаток',
  SELECT_APPLICATION: 'Оберіть додаток',
  STATUS: 'Статус',
  CREATED_BY: 'Створив(-ла)',
  CREATED_AT: 'Дата створення',
  ENABLED: 'Увімкнено',
  DISABLED: 'Вимкнено',
  COPY_LINK: 'Копіювати посилання',
  LINK_COPIED: 'Посилання скопійовано',
  LINK_UNAVAILABLE: 'Публічну адресу не налаштовано',
  ENABLE: 'Увімкнути',
  DISABLE: 'Вимкнути',
  EDIT: 'Редагувати',
  DELETE: 'Видалити',
  DELETE_TITLE: 'Видалити це універсальне посилання?',
  DELETE_TEXT:
    'Посилання одразу перестане працювати для всіх, з ким ним поділилися. Це не вплине на людей, які вже проходять верифікацію.',
  CANCEL: 'Скасувати',
  SAVE: 'Зберегти',
  CREATE: 'Створити',
  EMPTY_TITLE: 'Поки що немає універсальних посилань',
  EMPTY_TEXT: 'Створіть посилання, щоб будь-хто міг самостійно розпочати верифікацію.',
  FLOW_CHANGE_WARNING:
    'Зміна процесу перевірки впливає лише на тих, хто відкриє посилання після цього. Ті, хто вже проходить верифікацію, продовжують за попереднім процесом.',
  NAME_REQUIRED: "Назва обов'язкова",
  FLOW_REQUIRED: "Процес перевірки обов'язковий",
  APPLICATION_REQUIRED: "Додаток обов'язковий",
};

export default locale;
